<template>
  <Modal :id="'cmp-distribution-suppliers-add_order_form'" @cancelled="onCancel">
    <template slot="header">{{
      $dft.snakeCaseToWords("order")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <Dropdown
          :listHeight="500"
            :id="'supply_order_type'"
            class="m2"
            :options="supplier_typeTV"
            :selected="
              supplier_typeTV.find((b) => b.value == supply_order_type)
            "
            :placeholder="$t('type')"
            box
            @selectedChange="(b) => onDropdownChange('supply_order_type', b)"
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { SuppliersService } from "../../services/suppliers.service";

export default {
  components: {
    Modal,
    TextField,
  },
  props: ["selectedSupplierDetails"],
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        isModel: true,
      },
      supply_order_type: 1,
      supply_order_type_name:null
    };
  },
  computed: {
    supplier_typeTV: function () {
      return [
        { text: "Manufacturing", value: 1 },
        { text: "Purchase Order", value: 2 },
        { text: "Purchase Return", value: 3 },
        { text: "Defects Credit", value: 4 },
        { text: "Consignment", value: 5 },
        { text: "Consignment Return", value: 6 },
        { text: "Defects Consignment", value: 7 },
      ];
    },
  },
  methods: {
   
    onDropdownChange: function (name, value) {
      this.supply_order_type = value.value;
      this.supply_order_type_name=value.text;
    },
    onSave: async function () {
     const res = await SuppliersService.addSupplierOrder({
        supplier_id:
          this.selectedSupplierDetails?.supplier?.supplier_id,
       supply_order_type:this.supply_order_type,
      });
      //  console.log("res",res)
      this.$emit("added", {
        ...res.data,
        supply_order_type: this.supply_order_type,
      });
      this.onCancel();
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style></style>
